import React, { useState, useEffect } from "react"
import styles from "../BrokerCRM.module.css"

const questionsByStep = {
  property: {
    purchase: [
      "Is this your first property, or have you owned before?",
      "What’s the purchase price range and how much deposit do you have saved (and where is it held)?",
      "Do you already have a property in mind, or are you still looking?",
    ],
    refinance: [
      "What’s the main reason you’re refinancing (lower rate, cashback, debt consolidation, cash out)?",
      "Who is your current lender and what interest rate are you on?",
      "Do you want to access equity or consolidate any other debts (credit cards/personal loans)?",
    ],
  },
  applicants: [
    "Who will be on the application (just you, or with a partner)?",
    "What’s your current living situation (renting, own, living with family)?",
    "Do you have any dependants ?",
  ],
  income: [
    "What’s your base salary (before tax)?",
    "Do you earn any extra income (overtime, allowances, commission, bonuses, rental, centreliink)?",
  ],
  assets: [
    "How much do you have in savings (and is it in one account or split across accounts)?",
    "Do you own any property, vehicles, or other major assets?",
    "Do you have any shares?",
  ],
  expenses: [
    "Roughly what are your monthly living expenses (food, bills, utilities)?",
    
  ],
  objectives: [
    "What’s the main goal for this loan (lowest rate, flexibility, cash out, debt consolidation)?",
    "Do you prefer variable, fixed, or a split loan?",
    "Do you want an offset account and/or redraw for extra flexibility?",
  ],
  capacity: [
    "How much are you comfortable borrowing (even if the bank can lend more)?",
    "Do you want to compare a few lender options side-by-side?",
    "Should we stress test repayments if rates increase in the future?",
  ],
  review: [
    "Is everything here accurate, or is there anything you want to change?",
    "Are you ready for us to proceed and save this to Mercury for assessment?",
  ],
}

function SuggestedQuestions({ step, applicationType }) {
  const [typedText, setTypedText] = useState("")
  const [displayedQuestions, setDisplayedQuestions] = useState([])
  const [questionIndex, setQuestionIndex] = useState(0)
  const [charIndex, setCharIndex] = useState(0)
  const [questions, setQuestions] = useState([])

  // Load correct questions when step/applicationType changes
  useEffect(() => {
    let q = []

    if (step === "property" && applicationType) {
      q = questionsByStep.property[applicationType.toLowerCase()] || []
    } else if (step && step !== "property") {
      q = questionsByStep[step] || []
    }

    setQuestions(q)
    setDisplayedQuestions([])
    setTypedText("")
    setQuestionIndex(0)
    setCharIndex(0)
  }, [step, applicationType])

  // Typewriter effect
  useEffect(() => {
    if (questions.length === 0) return

    if (questionIndex < questions.length) {
      if (charIndex < questions[questionIndex].length) {
        const timeout = setTimeout(() => {
          setTypedText((prev) => prev + questions[questionIndex][charIndex])
          setCharIndex((prev) => prev + 1)
        }, 50)
        return () => clearTimeout(timeout)
      } else {
        setDisplayedQuestions((prev) => [...prev, questions[questionIndex]])
        setTypedText("")
        setCharIndex(0)
        setQuestionIndex((prev) => prev + 1)
      }
    }
  }, [charIndex, questionIndex, questions])

  return (
    <div className={styles.suggestedQuestions}>
      <h4>💡 Suggested Questions</h4>
      {questions.length > 0 ? (
        <ul>
          {displayedQuestions.map((q, i) => (
            <li key={i}>{q}</li>
          ))}
          {typedText && (
            <li>
              {typedText}
              <span className={styles.cursor}>|</span>
            </li>
          )}
        </ul>
      ) : (
        <p>Select an Application Type to see suggested questions.</p>
      )}
    </div>
  )
}

export default SuggestedQuestions